import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProfileProvider } from "./contexts/ProfileContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { SecurityProvider } from "./contexts/SecurityContext";
import { ToastProvider } from "./contexts/ToastContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";
// import { useInteractiveEffects } from "./hooks/useInteractiveEffects"; // DISABLED - too heavy
import "./styles/no-zoom.css";
import AdminLayout from "./layouts/AdminLayout";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Properties from "./pages/Properties";
import Gallery from "./pages/Gallery";
import Bookings from "./pages/Bookings";
import Payments from "./pages/Payments";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import ActivityLogs from "./pages/ActivityLogs";
import Analytics from "./pages/Analytics";
import UserManagement from "./pages/UserManagement";
import AdminDiscounts from "./pages/AdminDiscounts";
import Notifications from "./pages/Notifications";
import Login from "./pages/Login";
import PromoScreen from "./pages/PromoScreen";
import NotFound from "./pages/NotFound";
import PromoSettings from "./pages/PromoSettings";

export default function App() {
  // useInteractiveEffects(); // DISABLED - animasi terlalu berat

  return (
    <ErrorBoundary>
      <SecurityProvider>
        <LanguageProvider>
          <ThemeProvider>
            <AuthProvider>
              <ProfileProvider>
                <ToastProvider>
                  <BrowserRouter>
                    <Routes>
                      {/* Redirect root → login */}
                      <Route path="/" element={<Navigate to="/login" />} />

                      {/* Login page */}
                      <Route path="/login" element={<Login />} />

                      {/* Admin area - Protected */}
                      <Route path="/admin" element={
                        <ProtectedRoute>
                          <AdminLayout />
                        </ProtectedRoute>
                      }>
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="users" element={<Users />} />
                        <Route path="properties" element={<Properties />} />
                        <Route path="gallery" element={<Gallery />} />
                        <Route path="discounts" element={<AdminDiscounts />} />
                        <Route path="bookings" element={<Bookings />} />
                        <Route path="payments" element={<Payments />} />
                        <Route path="reports" element={<Reports />} />
                        <Route path="settings" element={<Settings />} />
                        <Route path="activity-logs" element={<ActivityLogs />} />
                        <Route path="analytics" element={<Analytics />} />
                        <Route path="user-management" element={<UserManagement />} />
                        <Route path="notifications" element={<Notifications />} />
                        <Route path="promo-settings" element={<PromoSettings />} />
                        <Route path="promo-screen" element={<PromoScreen />} />
                        {/* Default /admin → /admin/dashboard */}
                        <Route index element={<Navigate to="dashboard" />} />
                      </Route>

                      {/* Fallback 404 */}
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </BrowserRouter>
                </ToastProvider>
              </ProfileProvider>
            </AuthProvider>
          </ThemeProvider>
        </LanguageProvider>
      </SecurityProvider>
    </ErrorBoundary>
  );
}
